import { validateInvitationDocNumberMatch } from '../../../validations/docNumber';
import { useEffect } from 'react';

export const useInvitationDocNumberValidation = ({ userProfile, userProfileForm, onValidation }) => {
    const handleValidateInvitationDocNumberMatch = () => {
        if (!userProfileForm?.docNumber?.valid || !userProfile.jointHolderForm) return;

        const isValidDocNumberMatch = validateInvitationDocNumberMatch(
            userProfile.documentType,
            userProfile.docNumber,
            userProfile.jointHolderData.invite.doc
        );
        onValidation(isValidDocNumberMatch);
    };
    useEffect(() => {
        handleValidateInvitationDocNumberMatch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfileForm.docNumber]);

    return { handleValidateInvitationDocNumberMatch };
};
